<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <template v-if="value" v-html="value"></template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			return (this.item.user && this.item.user.wishlist && this.item.user.wishlist.text) ? this.item.user.wishlist.text : ''

		}

	}

}

</script>
